export default {
  prizeList: [
    {
      image: 'https://igamio.com/app_images/img/Iphone.png',
      title: 'iPhone 12'
    },
    {
      image: 'https://igamio.com/app_images/img/Mi-Smart-Band-5.png',
      title: 'Mi Smart Band 5'
    },
    {
      image: 'https://igamio.com/app_images/img/boAt-Rockerz-550.png',
      title: 'boAt Headphone'
    },
    {
      image: 'https://igamio.com/app_images/img/boAt-Stone-170.png',
      title: 'boAt 5W Speaker'
    },
    {
      image: 'https://igamio.com/app_images/img/Zebronics-ZEB.png',
      title: 'Zebronics Power Bank'
    }
  ],
  leagueTitle: 'Gadget League'
};
